export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14701.34421bb9.jpg";